/**
 * Adapter to use same methods whether
 * we chose to use SessionStorage, LocalStorage or Cookies.
 */
export class Storage {
  /**
   * Constructor
   *
   * @param storage either CookieAdapter/LocalStorageAdapter/SessionStorageAdapter
   */
  constructor(storage) {
    this.storage = storage;
  }

  /**
   * Get the element 'key' in the store
   *
   * @param key
   * @return {*}
   */
  get(key) {
    return this.storage.get(key);
  }

  /**
   * Set the element 'key' in the store to 'value'
   *
   * @param key
   * @param value
   */
  set(key, value) {
    try {
      this.storage.set(key, value);
    } catch (e) {
      // Nothing to do, storage is full, also
      // on Safari, IOS 10.1 LocalStorage is disabled.
      //
      // If we use storage more intensively check
      // http://crocodillon.com/blog/always-catch-localstorage-security-and-quota-exceeded-errors
      // @TODO Find a way to send log to the backend
    }
  }

  /**
   * Set the element 'key' in the store to 'value'
   *
   * @param key
   * @param value
   * @param ttl expires in sec
   */
  setJSON(key, value, ttl) {
    this.storage.setJSON(key, value, ttl);
  }

  /**
   * Get the element key in the store , it is supposed to be a JSON value.
   *
   * @param key
   * @return {*}
   */
  getJSON(key) {
    return this.storage.getJSON(key);
  }

  /**
   * Remove element 'key' from storage
   *
   * @param key
   * @return {*}
   */
  remove(key) {
    return this.storage.remove(key);
  }

  /**
   * Clear all the storage
   *
   * @return {*}
   */
  clear() {
    return this.storage.clear();
  }

  /**
   * Return the number of elements in the storage
   *
   * @return {*}
   */
  length() {
    return this.storage.length;
  }
}
